import {Stack} from '@mui/material';
import {findIndex} from 'lodash';
import {FC, useMemo} from 'react';
import {Controller} from 'react-hook-form';
import {SwitchField} from '../../../../../../../ui/switch-field';
import {useStepsFormContext} from '../../contexts';
import {useStepperStore} from '../../store/useStepperStore';
import {SelectField} from '../../../../../../../ui/select-field';
import {DATA_TYPE_OPTIONS} from './constants';
import {renderAdditionalFields} from './additional-fields-renderer';

interface Props {
  index: number;
}

export const Fields: FC<Props> = ({index}) => {
  const id = useStepperStore((s) => s.selectedStepId);
  const {control, watch} = useStepsFormContext();
  const steps = watch('steps');
  const activeStepIndex = useMemo(() => findIndex(steps, {id: String(id)}), [steps, id]);
  const currentDataType = watch(`steps.${activeStepIndex}.fieldGroups.${index}.dataType`);

  return (
    <Stack gap="46px">
      <Stack width="48%" gap="14px" mt="-8px">
        <Controller
          name={`steps.${activeStepIndex}.fieldGroups.${index}.isRequired`}
          control={control}
          render={({field}) => (
            <SwitchField
              justifyContent="space-between"
              label="Обязательное поле"
              checked={field.value}
              onChange={field.onChange}
              labelColor="#000"
            />
          )}
        />
        <Controller
          name={`steps.${activeStepIndex}.fieldGroups.${index}.editableAfterSubmit`}
          control={control}
          render={({field}) => (
            <SwitchField
              justifyContent="space-between"
              label="Возможность править после ввода"
              checked={field.value}
              onChange={field.onChange}
              labelColor="#000"
            />
          )}
        />
        <Controller
          name={`steps.${activeStepIndex}.fieldGroups.${index}.editModeOnly`}
          control={control}
          render={({field}) => (
            <SwitchField
              justifyContent="space-between"
              label="Включать только в режиме доработки"
              checked={field.value}
              onChange={field.onChange}
              labelColor="#000"
            />
          )}
        />
        <Controller
          name={`steps.${activeStepIndex}.fieldGroups.${index}.forWebOnly`}
          control={control}
          render={({field}) => (
            <SwitchField
              justifyContent="space-between"
              label="Не отображать в мобильном приложении"
              checked={field.value}
              onChange={field.onChange}
              labelColor="#000"
            />
          )}
        />
      </Stack>
      <Stack gap="20px">
        <Stack>
          <Controller
            name={`steps.${activeStepIndex}.fieldGroups.${index}.dataType`}
            control={control}
            render={({field}) => (
              <SelectField
                label="Тип данных"
                placeholder="Ввод текста"
                maxWidth="362px"
                options={DATA_TYPE_OPTIONS}
                {...field}
              />
            )}
          />
        </Stack>
        <Stack minHeight={'90px'}>
          {!!currentDataType && renderAdditionalFields(currentDataType, {index, activeStepIndex, control})}
        </Stack>
      </Stack>
    </Stack>
  );
};
